/* eslint-disable jsx-a11y/alt-text */
/* eslint-disable @nx/enforce-module-boundaries */
'use client';
import { Avatar } from '@mybridge/ui/avatar';
import { Button } from '@mybridge/ui/button';
import {
  Box,
  Center,
  Container,
  Flex,
  HStack,
  Stack,
  VStack,
} from '@mybridge/ui/layout';
import {
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalHeader,
  ModalOverlay,
} from '@mybridge/ui/modal';
import { useContext, useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import ImageUploader from 'v4/components/image-uploader';
import './banner.module.scss';
import { useNumberFormatter } from '@mybridge/ui/custom-hooks/useNumberFormatter';
// eslint-disable-next-line @nx/enforce-module-boundaries
import {
  IconButton,
  Menu,
  MenuButton,
  MenuItem,
  MenuList,
  Text,
  Tooltip,
  Image,
  Popover,
  PopoverTrigger,
  PopoverContent,
  PopoverHeader,
  PopoverBody,
  PopoverFooter,
  PopoverArrow,
  PopoverCloseButton,
  PopoverAnchor,
  Portal,
  Divider,
  CloseButton,
} from '@mybridge/ui';

import {
  getUserCollege,
  getUserEducationName,
  getUserEducationSpan,
  getUserExperience,
  getUserExperienceSpan,
  getUserFullName,
  getUserLocation,
  getUserPosition,
  getUserProfilePic,
} from 'v4/lib/commons';
import { FollowersIcon } from '@mybridge/icons/Followers';
import Link from 'next/link';
import { MyProfileContext } from 'v4/components/profile/context';
import {
  getMyActivity,
  getUserInfoPDF,
  getUserProfileInfo,
  userProfileAddInfo,
} from 'v4/store/actions/user-profile.actions';
import { FILEIcon, PDFIcon } from '@mybridge/icons/FileIcons';
import { MyProfileMyBioDropdown } from '../my-bio-dropdown';
import { GlobalContext } from 'v4/snippets/global/context';
import { ChevronDownIcon } from '@chakra-ui/icons';
import { ChevronDown, ChevronUp, VerticalThreeDot, HorizontalThreeDot, NewPlusIcon } from '@mybridge/icons';
import { useDisclosure, useToast } from '@chakra-ui/react';
import { ProfileFeelingsPicker } from 'v4/components/profile/feelings-picker';
import { useRouter } from 'next/router';
import { getFeelingsAndActivities } from 'v4/store/actions/global.data.actions';
import { isMobile } from 'react-device-detect';
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';
import { useTranslator } from '@mybridge/ui/custom-hooks/useTranslation';
import { useDirection } from '@mybridge/ui/custom-hooks/useDirection';
import { ANALYTICS_EVENTS, trackEvent } from 'v4/utils/analyticsEvents';
// import { SiteShortcutLinks } from 'v4/snippets/dashboard/site-shortcut-links';

const Camera = (props) => {
  const { width = 43, height = 35 } = props;
  return (
    <svg
      width={width.toString()}
      height={height.toString()}
      viewBox="0 0 43 35"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0.556641 30.4626C0.556641 23.6626 0.556641 16.8626 0.556641 10.2073C0.556641 10.2073 0.556641 10.2073 0.556641 10.0626C1.13536 7.60303 2.87153 6.15622 5.33111 6.15622C6.9226 6.15622 8.65877 6.15622 10.2503 6.15622C10.3949 6.15622 10.5396 6.15622 10.6843 6.15622C10.6843 5.72218 10.6843 5.28814 10.6843 4.70942C10.829 2.24984 12.5652 0.513672 15.1694 0.513672C19.3652 0.513672 23.5609 0.513672 27.9013 0.513672C28.3354 0.513672 28.7694 0.513672 29.0588 0.658353C30.9396 1.23708 32.0971 2.68388 32.0971 4.70942C32.0971 5.14346 32.0971 5.72218 32.0971 6.15622C32.2417 6.15622 32.3864 6.15622 32.5311 6.15622C34.2673 6.15622 35.8588 6.15622 37.5949 6.15622C40.3439 6.15622 42.3694 8.18176 42.3694 10.9307C42.3694 12.0881 42.3694 13.3903 42.3694 14.5477C42.3694 19.6115 42.3694 24.6754 42.3694 29.7392C42.3694 30.752 42.08 31.7647 41.5013 32.6328C40.4886 33.9349 39.1864 34.5137 37.4503 34.5137C26.7439 34.5137 16.1822 34.5137 5.47579 34.5137C5.33111 34.5137 5.18643 34.5137 4.89707 34.5137C3.1609 34.369 1.85877 33.5009 0.990683 31.9094C0.846002 31.4754 0.701321 31.0413 0.556641 30.4626ZM21.3907 30.6073C27.0332 30.6073 31.663 25.9775 31.663 20.3349C31.663 14.6924 27.0332 10.2073 21.5354 10.0626C15.8928 10.0626 11.263 14.6924 11.263 20.1903C11.263 25.9775 15.8928 30.6073 21.3907 30.6073Z"
        fill={props.color ?? '#5B5B5B'}
      />
      <path
        d="M28.1907 20.3341C28.1907 23.9511 25.1524 26.9894 21.5354 27.1341C17.7736 27.1341 14.7354 24.0958 14.7354 20.4788C14.7354 16.8618 17.7736 13.6788 21.3907 13.6788C25.1524 13.5341 28.1907 16.5724 28.1907 20.3341Z"
        fill={props.color ?? '#5B5B5B'}
      />
    </svg>
  );
};

export const Banner = () => {
  const [isOpen, setIsOpen] = useState(false);
  const { userProfileInfo, profilePDFUrl } = useSelector(
    (state) => state.userProfile
  );
  const { feelingsAndActivities } = useSelector((s) => s.globalData) ?? {};
  const router = useRouter();
  const { jobPreferences, peopleSliderDisc, refetchActivityPosts } =
    useContext(MyProfileContext);
  const { t } = useTranslator();
  const direction = useDirection();
  const { openImagePopup } = useContext(GlobalContext);
  const { allConnectionIDs,  allDegreeConnectionsArr} = useSelector((state) => state.connection);
  const { circle } = allConnectionIDs ?? {};
  const [cropType, setCropType] = useState();
  const [loading, setLoading] = useState(false);
  const [profilePostData, setProfilePostData] = useState(null);
  const [selectedFeeling, setSelectedFeeling] = useState();
  const feelingDisc = useDisclosure();
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const toast = useToast();
  const [loadingPDF, setLoadingPDF] = useState(false);
  const side = typeof window !== 'undefined' ? document.documentElement.dir : 'ltr';
  const {
    first_name,
    last_name,
    slug,
    profile_banner_pic,
    position,
    user_uuid,
    feelings_activity,
    pronouns,
  } = userProfileInfo || {};
  const dispatch = useDispatch();

  const onClose = () => {
    setIsOpen(false);
  };

  const uploadCropedImg = async (img) => {
    const formData = {};
    if (cropType === 'profilePhoto') {
      formData['profile_pic'] = img;
    } else {
      formData['profile_banner_pic'] = img;
    }

    // if (profilePostData && profilePostData?.show_on_feed) {
    formData['post_description'] = profilePostData?.post_description ?? '';
    formData['show_on_feed'] = profilePostData?.show_on_feed ?? false;
    // }
    setLoading(true);
    await dispatch(userProfileAddInfo(formData, false))
      .then((res) => {
        dispatch(getUserProfileInfo());
        dispatch(getMyActivity());
        setProfilePostData(null);
        setLoading(false);
        setIsOpen(false);
        refetchActivityPosts();
      })
      .catch((e) => setLoading(false));
  };

  const updateFeelingsData = () => {
    const formData = {};
    formData['feelings'] = selectedFeeling?.id;
    setLoading(true);
    dispatch(userProfileAddInfo(formData, true))
      .then((res) => {
        dispatch(getUserProfileInfo());
        setLoading(false);
        setIsOpen(false);
        setSelectedFeeling();
      })
      .catch((e) => setLoading(false));
  };

  const removeSetFeeling = () => {
    const formData = {};
    formData['feelings'] = '';
    setLoading(true);
    dispatch(userProfileAddInfo(formData, true))
      .then((res) => {
        dispatch(getUserProfileInfo());
        setLoading(false);
        setIsOpen(false);
        setSelectedFeeling();
      })
      .catch((e) => setLoading(false));
  };

  const handlePopups = (type) => {
    setIsOpen((prevState) => !prevState);
    setCropType(type);
  };

  const getFeelingActivityGrammer = (category) => {
    switch (category) {
      case 'More':
        return '';
      case 'Attending':
        return 'Attending ';
      case 'Celebrating':
        return 'Celebrating ';
      case 'Feeling':
        return 'Feeling ';
      default:
        return '';
    }
  };

  const userName = getUserFullName(userProfileInfo);
  const userEducation = getUserEducationName(userProfileInfo);
  const userExperience = getUserExperience(userProfileInfo);
  const userProfilePic = getUserProfilePic(userProfileInfo);
  const eduSpan = getUserEducationSpan(userProfileInfo);
  const expSpan = getUserExperienceSpan(userProfileInfo);
  const userLocation = getUserLocation(userProfileInfo);
const { formatNumber } = useNumberFormatter();
  const startDate =
    userExperience?.start_month === '0'
      ? `Jan ${userExperience?.start_year}`
      : `${new Date(
        userExperience?.start_year,
        userExperience?.start_month - 1,
        1
      ).toLocaleString('default', { month: 'short' })} ${userExperience?.start_year
      }`;

  const endDate = userExperience?.currently_working
    ? 'Present'
    : `${new Date(
      userExperience?.end_year,
      userExperience?.end_month - 1,
      1
    ).toLocaleString('default', { month: 'short' })} ${userExperience?.end_year
    }`;

  useEffect(() => {
    if (selectedFeeling) updateFeelingsData();
  }, [selectedFeeling]);

  useEffect(() => {
    trackEvent(ANALYTICS_EVENTS.ProfileViewScreen, userProfileInfo?.slug || 'anonymous');
  }, []);

  function validateStartDate(Date) {
    // Check if startDate is undefined or invalid
    if (Date != 'Invalid Date undefined' && /\d/.test(Date)) {
      return true; // Invalid date or undefined
    }
    return false; // Valid startDate and year
  }

  // const requestProfilePDF = async () => {
  //   try {
  //     const res = await dispatch(getUserInfoPDF(userProfileInfo?.slug));
  //     const htmlContent = res?.payload;

  //     console.log(htmlContent, 'html')

  //     if (!htmlContent) {
  //       alert('Failed to get profile HTML from server.');
  //       return;
  //     }

  //     // Create hidden iframe
  //     const iframe = document.createElement('iframe');
  //     iframe.style.position = 'fixed';
  //     iframe.style.left = '0';
  //     iframe.style.top = '0';
  //     iframe.style.width = '0';
  //     iframe.style.height = '0';
  //     iframe.style.border = '0';
  //     iframe.style.opacity = '0';
  //     document.body.appendChild(iframe);

  //     const doc = iframe.contentDocument || iframe.contentWindow.document;
  //     doc.open();
  //     doc.write(htmlContent); // Use the HTML exactly as returned from backend
  //     doc.close();

  //     // Wait for everything to load before printing
  //     await new Promise(resolve => {
  //       const check = () => {
  //         if (doc.readyState === 'complete') resolve();
  //       };
  //       iframe.onload = check;
  //       check();
  //     });

  //     if (doc.fonts && doc.fonts.ready) {
  //       await doc.fonts.ready;
  //     }

  //     const imgs = Array.from(doc.images || []);
  //     await Promise.all(
  //       imgs.map(img =>
  //         img.complete ? Promise.resolve() : new Promise(r => { img.onload = img.onerror = r; })
  //       )
  //     );

  //     // Trigger the native print dialog
  //     iframe.contentWindow.focus();
  //     iframe.contentWindow.print();

  //     // Clean up
  //     setTimeout(() => iframe.remove(), 1000);

  //   } catch (err) {
  //     console.error(err);
  //     alert('Error generating PDF.');
  //   }
  // };

  const requestProfilePDF = async () => {
    try {
      setLoadingPDF(true);

      const res = await dispatch(
        getUserInfoPDF(userProfileInfo?.slug)
      );

      const htmlContent = res?.payload;

      if (!htmlContent) {
        toast({
          title: "Error",
          description: "Failed to get profile HTML.",
          status: "error",
          duration: 3000,
          isClosable: true,
        });
        return;
      }

      const userName = getUserFullName(userProfileInfo) || "Profile";

      const safeFileName = userName
        .replace(/[^a-z0-9_\- ]/gi, "")
        .trim();

      // Better print pagination styles
      const PRINT_STYLES = `
        <style id="__pdf_print_styles__">
          @page {
            size: A4;
            margin: 0px;
          }

          * {
            box-sizing: border-box;
            -webkit-print-color-adjust: exact !important;
            print-color-adjust: exact !important;
          }

          html,
          body {
            margin: 0;
            padding: 0;
            background: #ffffff;
            width: 100%;
          }

          img {
            max-width: 100%;
          }

          /* Prevent ugly section splitting */

          section,
          .page-section,
          .about-us-section,
          .skills-container,
          .experience-block-section,
          .profile-details-block,
          .skill-item {
            break-inside: avoid;
            page-break-inside: avoid;
          }

          /* Keep heading attached with content */

          h1,
          h2,
          h3,
          h4,
          h5,
          h6,
          .section-heading {
            break-after: avoid;
            page-break-after: avoid;
            page-break-inside: avoid;
          }

          h3.section-heading + * {
            break-before: avoid;
            page-break-before: avoid;
          }

          /* Avoid lonely headings */

          .page-section {
            margin-bottom: 14px;
          }

          /* Better spacing */

          .experience-block-section {
            margin-bottom: 12px;
          }

          .skill-item {
            margin-bottom: 10px;
          }

          /* Avoid image cuts */

          img,
          svg {
            break-inside: avoid;
            page-break-inside: avoid;
          }

          /* Improve text rendering */

          body {
            -webkit-font-smoothing: antialiased;
            text-rendering: optimizeLegibility;
          }

        </style>
      `;

      // Inject styles into HTML
      const finalHTML = htmlContent.includes("</head>")
        ? htmlContent.replace(
            "</head>",
            `${PRINT_STYLES}</head>`
          )
        : `${PRINT_STYLES}${htmlContent}`;

      const response = await fetch("/api/generate-pdf", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          html: finalHTML,
          fileName: `${safeFileName}_profile`,
        }),
      });

      if (!response.ok) {
        const errorText = await response.text();
        console.error(errorText);
        throw new Error("Failed to generate PDF");
      }

      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = `${safeFileName}_profile.pdf`;
      document.body.appendChild(a);
      a.click();
      a.remove();
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error("PDF generation error:", error);

      toast({
        title: "Error",
        description: "Failed to generate PDF.",
        status: "error",
        duration: 3000,
        isClosable: true,
      });

    } finally {
      setLoadingPDF(false);
    }
  };

  const handleToggleMenu = () => {
    if (isMenuOpen) {
      handleHideMenu(); // Call the hide function
    } else {
      handleShowMenu(); // Call the show function
    }
    setIsMenuOpen(!isMenuOpen); // Toggle the state
  };

  const handleShowMenu = () => {
    if (!peopleSliderDisc.isOpen) {
      peopleSliderDisc.onToggle(true);
    }
  };

  const handleHideMenu = () => {
    if (peopleSliderDisc.isOpen) {
      peopleSliderDisc.onToggle(false);
    }
  };

  return (
    <>
      <Container maxW="700px" p={0}>
        <Stack >
          <HStack flexDir={['column', 'column', 'row']}
            alignItems="flex-start">

            <Box
              bgImage={
                profile_banner_pic &&
                  !profile_banner_pic.includes('banner-placeholder1.png')
                  ? profile_banner_pic
                  : '/images/defaultBanner.svg'
              }
              w="100%"
              h={['200px', '200px', '255px']}
              borderRadius="4px 4px 4px 4px"
              bgPosition="center"
              bgSize="cover"
              bgRepeat="no-repeat"
              position="relative"
              display="flex"
              justifyContent="center"
              pos="relative"
              role="group"

              _hover={{ opacity: 0.9 }}
              cursor={profile_banner_pic && "pointer"}
              onClick={(e) => {
                if(profile_banner_pic){
                  openImagePopup(profile_banner_pic, 'profile-banner')
                }
              }}
            >
              {isMobile ? (
                <IconButton
                  _groupHover={{ opacity: 1 }}
                  opacity={[1, 1, 0]}
                  icon={<Camera width={20} />}
                  variant="secondary"
                  onClick={(e) => {
                    e?.stopPropagation?.();
                    e?.preventDefault?.();
                    setCropType('profile_banner_pic');
                    setIsOpen(true);
                  }}
                  pos="absolute"
                  right="2"
                  bottom="2"
                />
              ) : (
                <Button
                  _groupHover={{ opacity: 1 }}
                  opacity={[1, 1, 0]}
                  leftIcon={<Camera width={20} />}
                  variant="secondary"
                  onClick={(e) => {
                    e?.stopPropagation?.();
                    e?.preventDefault?.();
                    setCropType('profile_banner_pic');
                    setIsOpen(true);
                  }}
                  pos="absolute"
                  // right="2"
                  {...(side === 'rtl' ? { left: '2' } : { right: '2' })}
                  bottom="2"
                >
                  {t('pages.uploadBanner') || "Upload Banner"}
                </Button>
              )}
            </Box>
          </HStack>
        </Stack>
      </Container>
      
      <Container maxW="1220px" p={0}>
        {isMobile ? (
          <>
            <VStack alignItems="flex-start">
              <Stack mt="-16" direction="row" spacing={0} align="center">
                <Box pos="relative" ml="10px">
                  <Avatar
                    // cursor="pointer"
                    cursor={userProfilePic && "pointer"}
                    name={userName}
                    size="doubleXl"
                    src={userProfilePic}
                    onClick={(e) => {
                      if (userProfilePic) {
                        openImagePopup(userProfilePic, 'user-profile');
                      }
                    }}
                    border="2px solid white"
                  />
                  <Box
                    pos="absolute"
                    bottom="0"
                    right="0"
                    borderRadius="full"
                    bg="brandGray.300"
                    cursor="pointer"
                    border="2px solid #fff"
                    p={2}
                    onClick={(e) => {
                      setCropType('profilePhoto');
                      setIsOpen(true);
                    }}
                  >
                    <Camera width={20} height={20} color={'#747474'} />
                  </Box>
                </Box>

                <Flex
                  direction="row"
                  align="center"
                  justify="flex-end"
                  w="full"
                  mt="60px"
                  gap="10px" // Space between Button and Menu
                >
                  <HStack gap={3} mt={4} mb={5}>
                    <Popover {...feelingDisc}>
                      <PopoverTrigger>
                        <Button
                          bg="white"
                          color="#868585"
                          borderRadius="27px"
                          w={isMobile&&"160px"}
                          border="1px solid #00000033"
                          _hover={{ bg: "#E4E6EB", color: "#5B5B5B", borderColor: "1px" }}
                          leftIcon={
                            selectedFeeling ? (
                              <Image
                                src={selectedFeeling?.file}
                                width="22"
                                height="22"
                              />
                            ) : (
                              <></>
                            )
                          }
                        >
                          {selectedFeeling
                            ? selectedFeeling?.name
                            : t('profile.whatIsGoingOn') || 'What is going on?'}
                        </Button>
                      </PopoverTrigger>
                      <Portal>
                        <PopoverContent w={!isMobile?"md":"sm"}>
                          <PopoverBody p={4} w={!isMobile?"md":"sm"}>
                            {feelingsAndActivities && (
                              <ProfileFeelingsPicker
                                setFeeling={(value) => {
                                  feelingDisc?.onClose();
                                  setSelectedFeeling(value);
                                }}
                                onClickClose={(e) => {
                                  if (e) feelingDisc?.onClose();
                                }}
                              />
                            )}
                          </PopoverBody>
                        </PopoverContent>
                      </Portal>
                    </Popover>
                    {/* <Button
                  as={Link}
                  href={'/p/' + userProfileInfo?.slug}
                  variant="secondary"
                >
                  View as Public
                </Button> */}
                    {/* <MyProfileMyBioDropdown jobPreferences={jobPreferences} /> */}

                    {/* <IconButton
                            variant="secondary"
                            icon={<ChevronDown />}
                            onClick={handleShowMenu}
                            sx={{
                              bg: "white",
                              borderRadius: '27px',
                              border: '1px solid #00000033',
                              opacity: 1,
                              _hover: {
                                backgroundColor: '#E4E6EB',
                                color: 'inherit',
                              },
                            }}
                          />
                          <IconButton
                            variant="secondary"
                            icon={<ChevronUp />}
                            onClick={handleHideMenu}
                            sx={{
                              bg: "white",
                              borderRadius: '27px',
                              border: '1px solid #00000033',
                              opacity: 1,
                              _hover: {
                                backgroundColor: '#E4E6EB',
                                color: 'inherit',
                              },
                            }}

                          /> */}
                    {!isMobile && <Menu >
                      <MenuButton
                        as={IconButton}
                        icon={<HorizontalThreeDot />}
                        sx={{
                          borderRadius: '27px ',
                          border: '1px solid #00000033',
                          backgroundColor: 'transparent',
                          color: 'inherit',
                          _hover: {
                            backgroundColor: '#E4E6EB',
                            color: 'inherit',
                          },
                          _focus: {
                            backgroundColor: 'white',
                            color: 'inherit',
                          },
                        }}
                      />
                      <Portal>
                        <MenuList>
                          <MenuItem
                            onClick={() =>
                              router.push('/p/' + userProfileInfo?.slug)
                            }
                          >
                            {t('myCalendar.viewAsPublic') || "View as public"}
                          </MenuItem>
                          <MenuItem onClick={() => requestProfilePDF()}>
                            {t('profile.saveToPDF') || "Save to PDF"}
                          </MenuItem>
                        </MenuList>
                      </Portal>
                    </Menu>}
                  </HStack>

                  <Menu>
                    <MenuButton
                      as={IconButton}
                      icon={<HorizontalThreeDot />}
                      sx={{
                        borderRadius: '27px',
                        border: '1px solid #00000033',
                        backgroundColor: 'transparent',
                        color: 'inherit',
                        _hover: {
                          backgroundColor: '#E4E6EB',
                          color: 'inherit',
                        },
                        _focus: {
                          backgroundColor: 'white',
                          color: 'inherit',
                        },
                      }}
                    />
                    <Portal>
                      <MenuList>
                        <MenuItem
                          onClick={() => router.push('/p/' + userProfileInfo?.slug)}
                        >
                          {t('myCalendar.viewAsPublic') || "View as public"}
                        </MenuItem>
                        <MenuItem onClick={() => requestProfilePDF()}>{t('profile.saveToPDF') || "Save to PDF"}</MenuItem>
                      </MenuList>
                    </Portal>
                  </Menu>
                </Flex>
              </Stack>

              <Stack  flex={1} direction={['column', 'row']} zIndex="1" pl={"25px"}>
                <Stack>
                  <Stack
                    spacing={0}
                    justifyContent="flex-start"
                    alignItems="start"
                  >
                    <Stack spacing={[1, 1, 1]}>
                      <HStack>
                        <Text
                          // fontWeight="bold"
                          color="brandPrimary.500"
                          fontSize={isMobile?"20px":"30px"}
                          textAlign="start"
                        >
                          {userName}{' '}
                          {pronouns && !pronouns.includes(null)
                            ? `(${pronouns})`
                            : ``}
                        </Text>
                        {userProfileInfo?.is_beta && userProfileInfo?.beta_status==='completed' && (
                          <Box 
                            bg="orange.100" 
                            borderRadius="full" 
                            px={2} 
                            py={1}
                          >
                            <Text 
                              fontSize="10px" 
                              fontWeight="bold" 
                              color="orange.600"
                              textTransform="uppercase"
                            >
                              Beta
                            </Text>
                          </Box>
                        )}
                      </HStack>
                    </Stack>
                    <Box textAlign="start">
                      {userExperience?.id ? (
                        <>
                          <Text fontSize="14px" display="inline">
                            {userExperience?.title + ' at '}
                          </Text>
                          <Text fontSize="14px" display="inline" fontWeight="bold">
                            {userExperience?.company_name}
                          </Text>
                        </>
                      ) : userEducation?.id ? (
                        <>
                          <Text fontSize="14px" display="inline">Student at </Text>
                          <Text display="inline" fontWeight="bold">
                            {userEducation?.name}
                          </Text>
                        </>
                      ) : (
                        ''
                      )}
                    </Box>
                    {!isMobile && (<HStack spacing={1} fontSize="14px" alignItems="start">
                      <Text color="blackAlpha.600">
                        {startDate} - {endDate}
                      </Text>
                      <Text fontSize="14px" color="blackAlpha.600">
                        ·
                      </Text>
                      <Text fontSize="14px" color="blackAlpha.600">{userLocation}</Text>
                    </HStack>)}

                    {isMobile && (<HStack spacing={1} textAlign="start" alignItems="start" display="block">
                      <Text fontSize="14px" color="blackAlpha.600">
                        {startDate} - {endDate} .
                      </Text>

                      <Text fontSize="14px" color="blackAlpha.600">{userLocation}</Text>
                    </HStack>)}

                  </Stack>
                </Stack>
              </Stack>

              <VStack
                justifyContent={['flex-start', 'flex-start', 'space-between']}
                alignItems="flex-start"
                zIndex="1"
                ml="25px"
              >
                <VStack gap="3">
                  {circle?.length ? (
                    <Text color={["#4F4F4F", "blackAlpha.500"]} minW="190px">
                      {circle?.length } {
                        circle?.length === 1 ? 'Connection' : 'Connection(s)'
                      }
                    </Text>
                  ) : (
                    <Box minW="140px"></Box>
                  )}

                  {feelings_activity && (
                    <Box
                      borderRadius="full"
                      px={3}
                      py={1}
                      className="primaryGradiantButton"
                    >
                      <HStack>
                        <Flex
                          width="25px"
                          height="25px"
                          bg="white"
                          borderRadius="full"
                          justifyContent="center"
                          alignItems="center"
                        >
                          <Image
                            src={feelings_activity?.file}
                            width="22"
                            height="22"
                          />
                        </Flex>
                        <Text color="#fff" fontSize="14px">
                          {getFeelingActivityGrammer(
                            feelings_activity?.category
                          )}
                          {feelings_activity?.name}
                        </Text>
                        <Center height="14px">
                          <Divider
                            orientation="vertical"
                            borderColor="white"
                            opacity="1"
                          />
                        </Center>
                        <Tooltip label="Remove">
                          <CloseButton
                            color="white"
                            size="sm"
                            onClick={() => removeSetFeeling()}
                          />
                        </Tooltip>
                      </HStack>
                    </Box>
                  )}
                </VStack>

                {/* <HStack gap={3}>
                  <Popover {...feelingDisc}>
                    <PopoverTrigger>
                      <Button
                        bg="#E4E6EB"
                        color="#5B5B5B"
                        leftIcon={
                          selectedFeeling ? (
                            <Image
                              src={selectedFeeling?.file}
                              width="22"
                              height="22"
                            />
                          ) : (
                            <></>
                          )
                        }
                      >
                        {selectedFeeling
                          ? selectedFeeling?.name
                          : 'What is going on?'}
                      </Button>
                    </PopoverTrigger>
                    <Portal>
                      <PopoverContent
                        w={['100%', 'md']}
                        maxW={['380px', 'none']}
                        overflowX="auto"
                      >
                        <PopoverBody p={4} w="100%">
                          {feelingsAndActivities && (
                            <ProfileFeelingsPicker
                              setFeeling={(value) => {
                                feelingDisc?.onClose();
                                setSelectedFeeling(value);
                              }}
                              onClickClose={() => feelingDisc?.onClose()}
                            />
                          )}
                        </PopoverBody>
                      </PopoverContent>
                    </Portal>
                  </Popover>

                  <IconButton
                    variant="secondary"
                    icon={
                      peopleSliderDisc?.isOpen ? <ChevronUp /> : <ChevronDown />
                    }
                    onClick={() => peopleSliderDisc.onToggle()}
                  />
                  <Menu zIndex="5">
                    <MenuButton>
                      <VerticalThreeDot height="20px" />
                    </MenuButton>
                    <Portal>
                      <MenuList>
                        <MenuItem
                          onClick={() =>
                            router.push('/p/' + userProfileInfo?.slug)
                          }
                        >
                          View as Public
                        </MenuItem>
                        <MenuItem>Save to PDF</MenuItem>
                      </MenuList>
                    </Portal>
                  </Menu>
                </HStack> */}

             
              </VStack>
            </VStack>
          </>
        ) : (
          <Stack ps="4">
            <HStack>
              <Stack mt="-16">
                <Box pos="relative">
                  <Avatar
                    key={userProfilePic}
                    cursor={userProfilePic && "pointer"}
                    // _hover={{ opacity: 0.9 }}
                    name={userName}
                    size={['xl', 'xl', 'doubleXl']}
                    src={userProfilePic}
                    onClick={(e) => {
                      if(userProfilePic) {
                        openImagePopup(userProfilePic, 'user-profile')
                      }
                    }}
                    border="3px solid white"
                  />
                  <Box
                    pos="absolute"
                    bottom="0"
                    right="0"
                    borderRadius="full"
                    bg="brandGray.300"
                    cursor="pointer"
                    border="2px solid #fff"
                    p={2}
                    onClick={(e) => {
                      setCropType('profilePhoto');
                      setIsOpen(true);
                    }}
                  >
                    <Camera width={20} height={20} color={'#747474'} />
                  </Box>
                </Box>
              </Stack>
              <Box
                position="absolute"
                top="260"
                left="175"
                p={3} // Add padding if needed
                zIndex="2" // Ensure it appears above other elements
              >
                {feelings_activity && (
                  <Box
                    borderRadius="full"
                    px={1}
                    py={1}
                    className="primaryGradiantButton"
                  >
                    <HStack>
                      <Flex
                        width="26px"
                        height="26px"
                        bg="white"
                        borderRadius="full"
                        justifyContent="center"
                        alignItems="center"
                      >
                        <Image
                          src={feelings_activity?.file}
                          width="23"
                          height="23"
                        />
                      </Flex>
                      <Text color="#fff" fontSize="14px">
                        {getFeelingActivityGrammer(feelings_activity?.feeling_category)}
                        {feelings_activity?.name}
                      </Text>
                      <Center height="14px">
                        <Divider
                          orientation="vertical"
                          borderColor="white"
                          opacity="1"
                        />
                      </Center>
                      <Tooltip label="Remove">
                        <CloseButton
                          color="white"
                          size="sm"
                          onClick={() => removeSetFeeling()}
                        />
                      </Tooltip>
                    </HStack>
                  </Box>
                )}
              </Box>
              <Box
                position="absolute"
                top="255"
                {...(side === 'ltr') ? { right: '-30' } : { left: '-30' }}
                p={3}
                zIndex="2"
              >
                {circle?.length ? (
                  <Popover trigger="hover" placement="bottom-start">
                    <PopoverTrigger>
                      <Text 
                        color="#868585" 
                        fontSize='14px' 
                        fontWeight={400} 
                        minW="140px"
                        cursor="pointer"
                        _hover={{ color: "#3D5A80", textDecoration: "underline" }}
                      >
                        {formatNumber(circle?.length)}{' '}
                        {circle?.length === 1
                          ? t('profile.connection') || 'Connection'
                          : t('profile.connections') || 'Connections'}
                      </Text>
                    </PopoverTrigger>
                    <Portal>
                      <PopoverContent 
                        bg="white"
                        borderRadius="xl" 
                        w="350px" 
                        maxH="500px" 
                        boxShadow="lg"
                        border="1px solid"
                        borderColor="gray.200"
                        overflow="hidden"
                      >
                        {/* Header - Outside scroll area */}
                        <Box
                          bg="gray.50"
                          borderRadius="lg"
                          p={4}
                        >
                          <Text 
                            fontWeight="bold" 
                            fontSize="md"
                          >
                            {t('profile.connections') || 'Connections'}
                          </Text>
                        </Box>
                        
                        {/* Scrollable connections list */}
                        <Box
                          bg="white"
                          border="1px solid"
                          borderColor="gray.100"
                          overflow="hidden"
                          maxH="300px"
                        >
                          <Box
                            maxH="300px"
                            overflowY="auto"
                            css={{
                              '&::-webkit-scrollbar': {
                                width: '6px',
                              },
                              '&::-webkit-scrollbar-track': {
                                background: '#f1f1f1',
                                borderRadius: '10px',
                              },
                              '&::-webkit-scrollbar-thumb': {
                                background: '#c1c1c1',
                                borderRadius: '10px',
                              },
                              '&::-webkit-scrollbar-thumb:hover': {
                                background: '#a8a8a8',
                              },
                            }}
                          >
                            <VStack spacing={0} align="stretch">
                              {/* Circle Connections from allDegreeConnectionsArr[0] */}
                              {allDegreeConnectionsArr?.[0]?.slice(0, 10).map((connection, index) => (
                                <HStack
                                  key={`circle-${connection.user_uuid || connection.id || index}`}
                                  p={4}
                                  _hover={{ bg: "gray.50" }}
                                  cursor="pointer"
                                  onClick={() => router.push(`/p/${connection.slug}`)}
                                  borderBottom="1px solid"
                                  borderColor="gray.100"
                                  _last={{ borderBottom: "none" }}
                                >
                                  <Avatar
                                    size="sm"
                                    src={connection.profile_pic || connection.default_profile_picture}
                                    name={connection.display_name || `${connection.first_name} ${connection.last_name}`}
                                  />
                                  <VStack align="start" spacing={0} flex={1}>
                                    <Text fontSize="sm" fontWeight="medium" noOfLines={1}>
                                      {connection.display_name || `${connection.first_name} ${connection.last_name}`}
                                    </Text>
                                    <Text fontSize="xs" color="gray.500" noOfLines={1}>
                                      {connection.position || connection.experiences?.[0]?.title || 'Connection'}
                                    </Text>
                                    {connection?.location && (
                                      <Text fontSize="xs" color="gray.400" noOfLines={1}>
                                        {connection.location}
                                      </Text>
                                    )}
                                  </VStack>
                                  <VStack align="end" spacing={0}>
                                    <Text fontSize="xs" color="blue.500">
                                      1st
                                    </Text>
                                    {connection.mutual_connection_count > 0 && (
                                      <Text fontSize="xs" color="gray.400">
                                        {formatNumber(connection.mutual_connection_count)} 
                                        {t(`profileNetwork.mutual`)|| ' Mutual'}
                                      </Text>
                                    )}
                                  </VStack>
                                </HStack>
                              ))}
                              
                              {/* Show message if no connections to display */}
                              {(!allDegreeConnectionsArr?.[0]?.length) && (
                                <Center p={4}>
                                  <Text fontSize="sm" color="gray.500">No connections to show</Text>
                                </Center>
                              )}
                          </VStack>
                        </Box>
                      </Box>

                      {/* Footer - Outside scroll area */}
                      {(circle?.length || 0) > 0 ? (
                        <Box 
                          p={4} 
                          textAlign="center"
                          bg="gray.50"
                          borderRadius="lg"
                        >
                          <Text
                            fontSize="sm"
                            color="blue.500"
                            cursor="pointer"
                            _hover={{ textDecoration: "underline" }}
                            onClick={() => router.push('/profile/network/my-circle')}
                          >
                            {t('profile.viewAllConnections') || "View All Connections"}
                          </Text>
                        </Box>
                      ) : null}
                    </PopoverContent>
                    </Portal>
                  </Popover>
                ) : (
                  <Box minW="140px"></Box>
                )}
              </Box>
            </HStack>
            <HStack
            pl={!isMobile&&2}
              // justifyContent={['center', 'flex-start', 'left']}
              {...(direction === 'rtl') ? { justifyContent: ['center', 'flex-start', 'right']} : { justifyContent: ['center', 'flex-start', 'left'] }}
              zIndex="1"
            >
              <HStack gap="30px">
                <Stack pt="4" flex={1} direction={['column', 'row']} zIndex="1" >
                  <Stack>
                    <Stack spacing={0}>
                      <Stack spacing={[1, 1, 1]}>
                        <HStack marginTop='-12px'>
                          <Text
                            fontWeight="400"
                            color="#3D5A80"
                            fontSize="30px"
                            noOfLines="2"
                          >
                            {userName}{' '}
                            {pronouns && !pronouns.includes(null)
                              ? `(${pronouns})`
                              : ``}
                          </Text>
                          {userProfileInfo?.is_beta && userProfileInfo?.beta_status==='completed' && (
                            <Box 
                              bg="orange.100" 
                              borderRadius="full" 
                              px={2} 
                              py={1}
                            >
                              <Text 
                                fontSize="12px" 
                                fontWeight="bold" 
                                color="orange.600"
                                textTransform="uppercase"
                              >
                                Beta
                              </Text>
                            </Box>
                          )}
                        </HStack>
                      </Stack>
                      <Box>
                        {userExperience?.id ? (
                          <>
                            <Text lineHeight="20px" display="inline">
                              {userExperience?.title + ' at '}
                            </Text>
                            <Text lineHeight="20px" display="inline" fontWeight="bold">
                              {userExperience?.company_name}
                            </Text>
                          </>
                        ) : userEducation?.id ? (
                          <>
                            <Text lineHeight="24px" display="inline">Student at </Text>
                            <Text lineHeight="24px" display="inline" fontWeight="bold">
                              {userEducation?.name}
                            </Text>
                          </>
                        ) : (
                          ''
                        )}
                      </Box>
                      <HStack>
                        {validateStartDate(startDate) && (
                          <Text lineHeight="24px" color="blackAlpha.600" fontSize="sm">
                            {startDate} - {endDate}
                          </Text>
                        )}
                        {validateStartDate(startDate) && (
                          <Text lineHeight="24px" color="blackAlpha.600" fontSize="2xl">
                            ·
                          </Text>
                        )}
                        <Text lineHeight="24px" color="#868585" fontSize="14px" fontWeight={400}>
                          {userProfileInfo?.location || userLocation || userExperience?.location}
                        </Text>

                      </HStack>
                      <HStack gap={3} mt={4} mb={5}>
                        <Popover {...feelingDisc}>
                          <PopoverTrigger>
                            <Button
                              bg="white"
                              color="#868585"
                              borderRadius="27px"
                              border="1px solid #00000033"
                              _hover={{ bg: "#E4E6EB", color: "#5B5B5B", borderColor: "1px" }}
                              leftIcon={
                                selectedFeeling ? (
                                  <Image
                                    src={selectedFeeling?.file}
                                    width="22"
                                    height="22"
                                  />
                                ) : (
                                  <></>
                                )
                              }
                            >
                              {selectedFeeling
                                ? selectedFeeling?.name
                                : t('profile.whatIsGoingOn') || 'What is going on?'}
                            </Button>
                          </PopoverTrigger>
                          <Portal>
                            <PopoverContent w={!isMobile?"md":"100%"}>
                              <PopoverBody p={4} w={!isMobile?"md":"100%"}>
                                {feelingsAndActivities && (
                                  <ProfileFeelingsPicker
                                    setFeeling={(value) => {
                                      feelingDisc?.onClose();
                                      setSelectedFeeling(value);
                                    }}
                                    onClickClose={(e) => {
                                      if (e) feelingDisc?.onClose();
                                    }}
                                  />
                                )}
                              </PopoverBody>
                            </PopoverContent>
                          </Portal>
                        </Popover>
                        {/* <Button
                as={Link}
                href={'/p/' + userProfileInfo?.slug}
                variant="secondary"
              >
                View as Public
              </Button> */}
                        {/* <MyProfileMyBioDropdown jobPreferences={jobPreferences} /> */}
                        <IconButton
                          variant="secondary"
                          icon={isMenuOpen ? <ChevronUp color="#868585" /> : <ChevronDown color="#868585" />}
                          onClick={handleToggleMenu}
                          sx={{
                            bg: "white",
                            borderRadius: "27px",
                            border: "1px solid #00000033",
                            opacity: 1,
                            _hover: {
                              backgroundColor: "#E4E6EB",
                              color: "inherit",
                            },
                          }}
                        />
                        {/* <IconButton
                          variant="secondary"
                          icon={<ChevronDown />}
                          onClick={handleShowMenu}
                          sx={{
                            bg: "white",
                            borderRadius: '27px',
                            border: '1px solid #00000033',
                            opacity: 1,
                            _hover: {
                              backgroundColor: '#E4E6EB',
                              color: 'inherit',
                            },
                          }}
                        />
                        <IconButton
                          variant="secondary"
                          icon={<ChevronUp />}
                          onClick={handleHideMenu}
                          sx={{
                            bg: "white",
                            borderRadius: '27px',
                            border: '1px solid #00000033',
                            opacity: 1,
                            _hover: {
                              backgroundColor: '#E4E6EB',
                              color: 'inherit',
                            },
                          }}

                        /> */}
                        <Menu >
                          <MenuButton
                            as={IconButton}
                            icon={<HorizontalThreeDot />}
                            isLoading={loadingPDF}
                            sx={{
                              borderRadius: '27px ',
                              border: '1px solid #00000033',
                              backgroundColor: 'transparent',
                              color: 'inherit',
                              _hover: {
                                backgroundColor: '#E4E6EB',
                                color: 'inherit',
                              },
                              _focus: {
                                backgroundColor: 'white',
                                color: 'inherit',
                              },
                            }}
                          />
                          <Portal>
                            <MenuList>
                              <MenuItem
                                onClick={() =>
                                  router.push('/p/' + userProfileInfo?.slug)
                                }
                              >
                                {t('profile.viewAsPublic') || "View as Public"}
                              </MenuItem>
                              <MenuItem onClick={() => requestProfilePDF()}>
                                {t('profile.saveToPDF') || "Save to PDF"}
                              </MenuItem>

                              <MyProfileMyBioDropdown fromPrivate={true} userName={userName} jobPreferences={jobPreferences} />
                            </MenuList>
                          </Portal>
                        </Menu>
                      </HStack>
                    </Stack>
                  </Stack>


                </Stack>



              </HStack>



            </HStack>
          </Stack>
        )}
      </Container>
      
      <Modal isOpen={isOpen} onClose={onClose} isCentered size="4xl">
        <ModalOverlay />
        <ModalContent>
          <ModalHeader color="#3D5A80" fontSize="lg">
            {t('pages.addPhoto') || "Add Photo"}
          </ModalHeader>
          <ModalCloseButton />
          <ModalBody pb={6}>
            <ImageUploader
              cropType={cropType}
              uploadCropedImg={uploadCropedImg}
              handlePopups={handlePopups}
              isLoading={loading}
              forProfile
              onProfilePostData={(e) => setProfilePostData(e)}
            />
          </ModalBody>
        </ModalContent>
      </Modal>
    </>
  );
};
export default Banner;
